export const environment = {
  production: true,
  connection: {
    name: 'Holz Braun Softline',
    host: 'https://softline.holz-braun.de/',
    port: 443,
    basePath: '/api',
  },
  androidUpdateRepository: 'f',
};
